module.exports = __webpack_public_path__ + "img/red_envelope.00dd8cdf.png";